<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 美食管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!--<el-button
                  type="primary"
                  icon="el-icon-delete"
                  class="handle-del mr10"
                  @click="delAllSelection"
                >批量删除
                </el-button>-->
                <el-select class="handle-select mr10 wd200" clearable placeholder="美食目录" v-model="search.menu">
                    <el-option :key="item.Id"
                               :label="item.Cname"
                               :value="item.Id"
                               v-for="item in foodOpt.city"></el-option>
                </el-select>
                <el-input class="handle-input mr10" clearable placeholder="美食名称" v-model="search.keyword"></el-input>
                <el-button @click="handleSearch" icon="el-icon-search" type="primary">搜索</el-button>
                <el-button @click="getFoodData" icon="el-icon-refresh" type="warning">刷新</el-button>
            </div>
            <el-table
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="Id" sortable width="65"></el-table-column>
                <el-table-column label="美食名称" prop="Fname" sortable></el-table-column>
                <el-table-column label="所属城市" prop="CityName" sortable></el-table-column>
                <el-table-column label="美食分类" prop="ProdType" sortable></el-table-column>

                <el-table-column :filter-method="filterTag" :filters="[{ text: '屏蔽中', value: '0' }, { text: '正显示', value: '1' }, { text: '正推荐', value: '3' }]"
                                 align="center"
                                 label="美食状态"
                                 prop="Fstate">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Fstate===0?'danger':(scope.row.Fstate===1?'success':'info')"
                        >{{scope.row.Fstate===0?'屏蔽中':(scope.row.Fstate===1?'正显示':'正推荐')}}
                        </el-tag>
                    </template>
                </el-table-column>

                <!--      <el-table-column sortable label="景点等级" align="center">
                        <template slot-scope="scope">
                          <el-tag>
                            {{scope.row.Sstar===0?'暂未评级':(scope.row.Sstar===1?'A':(scope.row.t===2?'AA':(scope.row.Sstar===3?'AAA':(scope.row.Sstar===4?'AAAA':'AAAAA'))))}}
                          </el-tag>
                        </template>
                      </el-table-column>-->
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-guide"
                                type="text"
                        >探店
                        </el-button>
                        <!--<el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="searchPage" v-show="show.search">
                共计 【 {{pageTotal}} 】条符合条件的结果
            </div>

            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :visible.sync="editVisible" title="编辑美食信息" width="30%">
            <el-form :model="form" label-width="70px" ref="form">
                <el-form-item label="美食名称">
                    <el-input class="wd200" v-model="form.Fname"></el-input>
                </el-form-item>
                <el-form-item label="所属区域">
                    <el-select placeholder="请选择" v-model="form.Fcity">
                        <el-option :key="item.Id"
                                   :label="item.cityName"
                                   :value="item.Id"
                                   v-for="item in foodOpt.pcity"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="美食类别">
                    <el-select placeholder="请选择" v-model="form.Fprotype">
                        <el-option :key="item.Id"
                                   :label="item.Tname"
                                   :value="item.Id"
                                   v-for="item in foodOpt.menu"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="美食状态">
                    <el-select placeholder="请选择" v-model="form.Fstate">
                        <el-option :key="item.value"
                                   :label="item.label"
                                   :value="item.value"
                                   v-for="item in foodOpt.state"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="美食特色">
                    <el-input
                            maxlength="500"
                            placeholder="请输入内容"
                            rows="10"
                            show-word-limit
                            type="textarea"
                            v-model="form.Fsummary"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="美食描述">
                    <el-input
                            maxlength="500"
                            placeholder="请输入内容"
                            rows="10"
                            show-word-limit
                            type="textarea"
                            v-model="form.Fdescription"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="浏览次数">
                    <el-input class="wd200" v-model="form.Fcount"></el-input>
                </el-form-item>

            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                foodOpt: {
                    city: [],
                    pcity: [],
                    menu: [],
                    state: [{
                        value: 0,
                        label: '屏蔽中'
                    }, {
                        value: 1,
                        label: '正显示'
                    }, {
                        value: 2,
                        label: '正推荐'
                    }]
                },
                query: {
                    address: '',
                    name: '',
                    pageIndex: 1,
                    pageSize: 10,
                    sdid: sessionStorage.getItem('ml_cityId')
                },
                search: {
                    keyword: '',
                    menu: '',
                    sdid: sessionStorage.getItem('ml_cityId')
                },
                show: {
                    page: true,
                    search: false
                },
                tableData: [],
                multipleSelection: [],
                delList: [],
                editVisible: false,
                addVisible: false,
                pageTotal: 0,
                form: {},
                idx: -1,
                id: -1
            };
        },
        created() {
            // this.reload();
            this.getFoodData();
        },
        methods: {
            async getFoodData() {
                const { data: res } = await this.$http.post('admin/foods/initFoodData', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取美食数据失败，请联系管理员!');
                }
                this.foodOpt.city = res.city;
                this.foodOpt.pcity = res.pcity;
                this.foodOpt.menu = res.menu;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal || 25;
                this.search.keyword = '';
                this.search.menu = '';
                this.show.page = true;
                this.show.search = false;
                this.$message.success('【美食数据】加载成功!');
            },
            // 触发搜索按钮
            async handleSearch() {
                console.log(this.search);
                const { data: res } = await this.$http.post('admin/foods/searchFood', {
                    search: this.search
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取美食数据失败，请联系管理员!');
                }
                this.foodOpt.city = res.city;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.show.page = false;
                this.show.search = true;
                this.$message.success('搜索成功，共有【 ' + res.pageTotal + ' 】符合条件的结果');
            },

            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAllSelection() {
                const length = this.multipleSelection.length;
                let str = '';
                this.delList = this.delList.concat(this.multipleSelection);
                for (let i = 0; i < length; i++) {
                    str += this.multipleSelection[i].name + ' ';
                }
                this.$message.error(`删除了${str}`);
                this.multipleSelection = [];
            },
            // 新增操作
            handleAdd() {
                this.addVisible = true;
            },
            async saveAdd() {
                const { data: res } = await this.$http.post('/admin/partner/addUser', {
                    form: this.form
                });
                if (res.code !== 200) {
                    this.addVisible = false;
                    return this.$message.error('系统错误，添加用户失败，请联系管理员!');
                }
                this.$message.success('添加用户成功!');
                this.addVisible = false;
                //  this.form=[];
            },

            // 编辑操作
            handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                console.log(row.Id);
                this.editVisible = true;
            },

            // 保存编辑
            async saveEdit() {
                this.editVisible = false;
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/partner/addFood', {
                    form: this.form
                });
                if (res.code !== 200) {
                    this.addVisible = false;
                    return this.$message.error('系统错误，修改数据失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.addVisible = false;
                //  this.form=[];
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getFoodData();
            },
            //标签筛选
            filterTag(value, row) {
                console.log('is runing' + value);
                return row.Fstate == value;
            }
        }
    };
</script>

<style scoped>

    .searchPage {
        font-size: 14px;
        color: #606266;
        padding: 20px 0px;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .wd200 {
        width: 200px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
